import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContadorDs } from "../../DataSources";


const localStorageKey = "cadastroContadoresGridState";

let _contadorCorrente = undefined;

export default class ContadorBox extends Component {

    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("contadores/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="CONTADORES" novoCb={this.novoContador.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarContadorDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} />
                            <Column dataField={'nome'} />
                            {/*
                            <Column dataField={'PrefeituraId'} caption={"Prefeitura"}>
                                <Lookup dataSource={prefeituraDs} valueExpr={'Id'} displayExpr={'NomeMunicipio'} />
                            </Column>
                        */
                            }
                            <Column dataField={'celular'} caption = {"Celular"} />
                            <Column dataField={'email'} caption={"E-mail"} customizeText={this.formatarEmail} />
                            <Column dataField={'telefone'} caption={"Fone"}/>
                            <Column dataField={'crc'} caption={"CRC"} />
                            <Column dataField={'tipoUsuario'} caption={"Tipo"} />
                            <Column dataField={'documento'} caption="CPF/CNPJ" />
                            <Column dataField={'cep'} caption={"CEP"} />
                            <Column dataField={'logradouro'} caption={"Logradouro"}/>
                            <Column dataField={'numero'} caption={"N.º"} />
                            <Column dataField={'complemento'} caption={"Complemento"} />
                            <Column dataField={'bairro'} caption={"Bairro"} />
                            <Column dataField={'estadoId'} caption={"Estado"} />
                            <Column dataField={'municipioId'} caption={"Município"}/>
                            <Column dataField={'rg'} caption={"RG"} />
                            <Column dataField={'orgaoExpedidor'} caption={"RG/Orgão"} />
                            <Column dataField={'ufrg'} caption={"RG/UF"} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    formatarEmail(cellInfo) {
        if (cellInfo.target === "row") {
            return (cellInfo.value || "").toLowerCase();
        }
    }

    novoContador() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("contadores/novo");
    }
}